import React from "react";
import PropTypes from "prop-types";

export default class CoupangPartners extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingCoupangBanner: false
    }
  }

  componentDidMount() {
    this.interv = setInterval(() => {
      if(this.setCoupangBanner()) {
        this.setState({
          isLoadingCoupangBanner: true
        });
        clearInterval(this.interv);
      }
    }, 100);
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.isLoadingCoupangBanner) {
      if(this.instance.getElementsByTagName('ins')[0]) {
        this.setCoupangBanner(nextProps);
      }
    }
  }

  setCoupangBanner = (nextProps) => {
    if(this.instance) {
      if(nextProps === undefined) {
        let ins = document.getElementsByTagName('ins')[0];
        let c_ins = this.instance.getElementsByTagName('ins')[0];
      
        if(ins && c_ins === undefined) {
          this.instance.appendChild(ins.cloneNode(true));
        }
      }

      let c_ins = this.instance.getElementsByTagName('ins')[0];

      if(c_ins) {
        if(c_ins.style.display !== 'inline') {
          c_ins.style.display = 'inline';
        }
        
        if(nextProps) {
          let iframe = c_ins.getElementsByTagName('iframe')[0];

          if(iframe) {
            iframe.width = nextProps.width;
            iframe.height = 140;
          }
        }
        return true;
      }
    }

    return false;
  }

  render() {
    return (
      <div
        id="coupang_partners"
        ref={el => (this.instance = el) }
        style={{ marginBottom: 20 }}
      />
    );
  }
}